import { Card, CardContent, Stack } from "@mui/material";
import { useEffect } from "react";
import { ViewToggleButtonGroup } from "../../../../components";
import { useBreakpoints, useSettings } from "../../../../hooks";

interface IProps {
  planGuid: string;
  content: React.ReactNode;
  isTableView: boolean;
  isPastView: boolean;
  onViewToggled: (value: boolean) => void;
}

const PlanHeader = (props: IProps) => {
  const { isMdUp } = useBreakpoints();
  const { teamStrategySettings, updateTeamStrategySettings } = useSettings();

  useEffect(() => {
    const settings = teamStrategySettings[props.planGuid];
    handleViewToggled(settings?.tableView ?? true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.planGuid]);

  function handleViewToggled(value: boolean) {
    props.onViewToggled(value);

    updateTeamStrategySettings(props.planGuid, {
      tableView: value,
    });
  }

  return (
    <Card>
      <CardContent>
        <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
          {props.content}
          {isMdUp && <ViewToggleButtonGroup isTableView={props.isTableView} onViewToggled={props.onViewToggled} />}
        </Stack>
      </CardContent>
    </Card>
  );
};

export { PlanHeader };
